import { createTheme, CssBaseline, ThemeProvider } from '@mui/material';
import { useMemo } from 'react';
import { useAppSelector } from 'src/redux/hooks';
import { getLocalization } from 'src/services/language-service';
import { themeSelectors } from '../redux/theme-slice';

interface AppThemeProps {
    children: React.ReactNode;
}

function AppThemeProvider({ children }: AppThemeProps) {
    const { paletteMode, locale } = useAppSelector(themeSelectors.all);

    const theme = useMemo(
        () =>
            createTheme(
                {
                    palette: {
                        mode: paletteMode,
                    },
                },
                getLocalization(locale),
            ),
        [paletteMode, locale],
    );

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            {children}
        </ThemeProvider>
    );
}

export default AppThemeProvider;
